import { AuthService } from '../service/auth.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@env/environment';

// @Injectable()
// export class ErrorInterceptor implements HttpInterceptor {
//   constructor(
//     private authenticationService: AuthService,
//     private router:Router,
//     private dialog: MatDialog
//   ) {}

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     return next.handle(request).pipe(
//       catchError((err) => {
//         // console.log(err)
//         if ((err.status === 401 || err.status === 403) && request.url.indexOf('/Login/')===-1) {
//           // console.log('renavigate.....',request.url)
//           // auto logout if 401 response returned from api
//           // this.authenticationService.logout();
//           Swal.fire('',err.error,'warning');
//           // location.reload(true);
//           this.logout();
//         }else if(err.status === 500){
//           if(environment.production)
//               Swal.fire('',err.statusText,'warning');
//           else
//           Swal.fire('','('+err.status+'-'+err.statusText+')'+err.error+'\n(Service URL:'+err?.url+')','warning');
//         }
//         // console.log(err)
//         let error=null;
//         if(err)
//            error = (err.message??err.error.message)  || err.statusText;
           
//           return throwError(error);
//       })
//     );
//   }

//   //#region Other Methods ------------------------------------------------------------------------------------
//   logout(): void {
//     this.dialog.closeAll();

//     this.authenticationService.logout();

//     this.router.navigate(['/authentication/signin']);
//   }
//   //#endregion Other Methods ---------------------------------------------------------------------------------
  
//   //#region Service Methods ----------------------------------------------------------------------------------
//   //#endregion Service Methods -------------------------------------------------------------------------------
  
//   //#region Observables Methods ------------------------------------------------------------------------------
//   //#endregion Observables Methods ---------------------------------------------------------------------------
  
//   //#region Re-Usable Methods --------------------------------------------------------------------------------
//   //#endregion Re-Usable Methods -----------------------------------------------------------------------------

// }

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(catchError((error) => {
    if (
      (error.status === 401 || error.status === 403  )
      && req.url.indexOf('/Login/') === -1 ||  error?.status === 400
    ) {
      // console.log('renavigate.....',request.url)
      // auto logout if 401 response returned from api
      // this.authenticationService.logout();
      Swal.fire('', error?.error?.error ? error?.error?.error :error?.error, 'warning');
      // location.reload(true);
    //  logout();
    }else if(error.status===500&&req.url.indexOf('/Patient/HTMLPreview')>-1) {
      return throwError(() => error);
    }else if(error.status===500&&req.url.indexOf('/Patient/DownloadXMLData_TOC')>-1) {
      // console.log(error)
      Swal.fire('', 'Download Failed!', 'warning');

    }else if(error.status===500&&req.url.indexOf('/Patient/DecryptExternalFiles')>-1){
      decryptExternalFiles(error);
      
    }
    else if (error?.status===500 &&error?.error?.error == "An error occurred while fetching emails.") {
      Swal.fire('', error?.error?.details, 'warning');
      return; 
    } 
    else if (error.status === 500) {
      if (environment.production) {
        Swal.fire('', error.statusText, 'warning');
      } else {
        Swal.fire({
          icon: 'warning',
          title: `${error.status + ' ' + error.statusText}
            <span class="font-weight-light font-14"> ${error.error} </span>`,
          html: `<b>Service URL: </b>` + `${error?.url}`
        });
      }
    }
     
  }));
   
}

function decryptExternalFiles(error):void{
  if(error?.error==="Padding is invalid and cannot be removed."){
    Swal.fire('','Encryption type or password mismatch.', 'warning');
  }else{
    Swal.fire({
      icon: 'warning',
      title: `${error.status + ' ' + error.statusText}
        <span class="font-weight-light font-14"> ${error.error} </span>`,
      html: `<b>Service URL: </b>` + `${error?.url}`
    });
  }
}

function logout(): void {
  this.dialog.closeAll();

  this.authenticationService.logout();

  this.router.navigate(['/authentication/signin']);
}
